'use client';

import React from 'react';
import { m, useReducedMotion } from 'motion/react';
import { css } from 'styled-system/css';

/** Lift the complete orb without moving its hover hit area. */
export function OrbHover({
  children,
  className,
}: {
  children: React.ReactNode;
  className: string;
}) {
  const reduce = useReducedMotion();

  return (
    <m.div data-orb-hover initial='rest' animate='rest' whileHover='hovered' className={className}>
      <m.div
        data-orb-float
        variants={{ rest: { y: 0 }, hovered: { y: reduce ? 0 : -6 } }}
        transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
        className={css({
          position: 'relative',
          w: 'full',
          h: 'full',
          display: 'grid',
          placeItems: 'center',
          borderRadius: 'inherit',
        })}
      >
        {children}
      </m.div>
    </m.div>
  );
}

/** Lens highlights follow the same 960 × 960 coordinates as poses/hero.webp. */
export function GlassesGlint() {
  const reduce = useReducedMotion();

  return (
    <m.svg
      data-orb-glint
      aria-hidden='true'
      focusable='false'
      viewBox='0 0 960 960'
      variants={{
        rest: { opacity: 0 },
        hovered: {
          opacity: reduce ? 0 : [0, 1, 1, 0],
          transition: { duration: 1.6, times: [0, 0.18, 0.42, 1], ease: 'easeInOut' },
        },
      }}
      className={css({
        position: 'absolute',
        inset: '0',
        w: 'full',
        h: 'full',
        pointerEvents: 'none',
        fill: 'fg.onBrand',
      })}
    >
      <path d='m267 510 24-8 25 60-24 6Z' opacity='0.7' />
      <path d='m435 456 30-10 35 84-28 8Z' opacity='0.8' />
      <g className={css({ filter: 'drop-shadow(0 0 4px {colors.fg.success})' })}>
        <path d='m555 414 6 26 26 6-26 6-6 26-6-26-26-6 26-6Z' />
        <path d='m277 490 3 11 11 3-11 3-3 11-3-11-11-3 11-3Z' opacity='0.8' />
      </g>
    </m.svg>
  );
}
